import { Icon } from '@/shared/types/icon';

const Bubble = ({ size = 46 }: Icon) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path
          fill="#1B66D6"
          d="M11.993 24c6.624 0 11.994-5.373 11.994-12S18.617 0 11.993 0C5.37 0 0 5.373 0 12s5.37 12 11.993 12Z"
        />
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M18 14.726s-.082 2.056.091 3.03c.1.563-.223 1.424-.76 1.249a5.482 5.482 0 0 1-1.261-.59C14.577 17.45 18 14.725 18 14.725Z"
          clipRule="evenodd"
        />
        <path
          fill="#fff"
          d="M11.989 19.36a7.411 7.411 0 0 0 7.408-7.413 7.41 7.41 0 0 0-7.408-7.413 7.41 7.41 0 0 0-7.41 7.413 7.41 7.41 0 0 0 7.41 7.413Z"
        />
        <path
          fill="#1B66D6"
          d="M12.578 9.062a1.05 1.05 0 0 0-1.04 1.06c0 .586.465 1.06 1.04 1.06h2.08a1.05 1.05 0 0 0 1.04-1.06 1.05 1.05 0 0 0-1.04-1.06h-2.08ZM10.144 15.21c.807 0 1.461-.667 1.461-1.49 0-.822-.654-1.489-1.46-1.489-.808 0-1.462.667-1.462 1.49 0 .822.654 1.489 1.461 1.489ZM9.535 10.964a.86.86 0 0 0 .853-.868.86.86 0 0 0-.853-.87.86.86 0 0 0-.852.87c0 .48.382.868.852.868ZM13.607 14.548a.86.86 0 0 0 .853-.869.86.86 0 0 0-.853-.869.86.86 0 0 0-.852.869c0 .48.382.869.852.869Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bubble;
